<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <user-stats></user-stats>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    UserStats: () => import(/* webpackPrefetch: true */ '../components/UserStats')
  }
}
</script>

<style scoped>

</style>
